module.exports = __webpack_public_path__ + "img/2.997e0458.jpg";